"use strict";
/* tslint:disable:no-unsafe-any */
Object.defineProperty(exports, "__esModule", { value: true });
var matches_1 = require("./matches");
var parent_1 = require("./parent");
var closestLib = function (element, selector, check_self) {
    if (check_self === void 0) { check_self = false; }
    var next = check_self ? element : parent_1.parent(element);
    while (next && next !== document) {
        if (matches_1.matches(next, selector)) {
            return next;
        }
        next = parent_1.parent(next);
    }
    return undefined;
};
exports.closest = function (e, selector, check_self) {
    if (check_self === void 0) { check_self = false; }
    return closestLib(e, selector, check_self);
};
exports.closestForce = function (e, selector, check_self) {
    if (check_self === void 0) { check_self = false; }
    var c = exports.closest(e, selector, check_self);
    if (c === undefined) {
        throw new ReferenceError("Could not find any matching ancestors with selector \"" + selector + "\"");
    }
    return c;
};
